import { tokens } from '@/lib/tokens.js';
import type { CSSProperties } from 'react';

type Status = 'active' | 'deprecated' | 'enabled' | 'disabled' | 'manual' | 'rule';
type Level = 'view' | 'execute' | 'full';

const STATUS_STYLES: Record<Status, CSSProperties> = {
  active: { backgroundColor: '#166534', color: '#bbf7d0' },
  deprecated: { backgroundColor: '#7f1d1d', color: '#fecaca' },
  enabled: { backgroundColor: '#166534', color: '#bbf7d0' },
  disabled: { backgroundColor: '#374151', color: '#9ca3af' },
  manual: { backgroundColor: '#1e3a5f', color: '#93c5fd' },
  rule: { backgroundColor: '#3b1f6e', color: '#d8b4fe' },
};

const LEVEL_STYLES: Record<Level, CSSProperties> = {
  view: { backgroundColor: '#1e3a5f', color: '#93c5fd' },
  execute: { backgroundColor: '#1e4620', color: '#86efac' },
  full: { backgroundColor: '#4c1d1d', color: '#fca5a5' },
};

const BASE: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '2px 8px',
  borderRadius: tokens.radius.badge,
  fontSize: '0.75rem',
  fontWeight: 500,
  lineHeight: '1.5',
  whiteSpace: 'nowrap',
};

export function StatusBadge({ status }: { status: Status }) {
  const style = STATUS_STYLES[status] ?? {};
  return <span style={{ ...BASE, ...style }}>{status}</span>;
}

export function LevelBadge({ level }: { level: Level }) {
  const style = LEVEL_STYLES[level] ?? {};
  const labels: Record<Level, string> = { view: 'View', execute: 'Execute', full: 'Full' };
  return <span style={{ ...BASE, ...style }}>{labels[level]}</span>;
}
